"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = exports.isDOMElement = void 0;
function isDOMElement(element) {
    return typeof HTMLElement === "object"
        ? element instanceof HTMLElement // DOM2
        : element.nodeType === 1 && typeof element.nodeName === "string";
}
exports.isDOMElement = isDOMElement;
function isFunction(value) {
    return typeof value === "function";
}
exports.isFunction = isFunction;
